import { Typography } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import useCountdown from 'hooks/useCountdown';
import { useSelector } from 'hooks/useSelector';
import { resendVerifyCode } from 'modules/auth/actions';
import {
  getResendLoading,
  getRetryExpiration,
  canResend as canResendSelector, isAccountLocked as isAccountLockedSelector
} from 'modules/auth/selectors';
import { Loader } from 'ui/base';

const { Link } = Typography;

const ResendWrapper = () => {
  const dispatch = useDispatch();

  const isResendLoading = useSelector(getResendLoading);
  const canResend = useSelector(canResendSelector);
  const retryExpiration = useSelector(getRetryExpiration);
  const isAccountLocked = useSelector(isAccountLockedSelector);

  const { countdown } = useCountdown({ date: retryExpiration });

  const isExpired = countdown === 0;
  const displayResendLink = canResend && !isResendLoading && !isAccountLocked && isExpired;

  const handleResend = React.useCallback(() => dispatch(resendVerifyCode()), [dispatch]);

  return (
    <div data-testid="resend-message" className="text-center">
      {!isExpired && (
        <FormattedMessage
          id="page.login.mfa.resendVerificationCodePending"
          defaultMessage="Did not receive the code? Check your spam folder or send a new code in {seconds} seconds."
          values={{ seconds: countdown }}
        />
      )}
      {isResendLoading && <Loader className="ml-2 d-inline" />}
      {displayResendLink && (
        <FormattedMessage
          id="page.login.mfa.resendVerificationCode"
          defaultMessage="Did not receive the code? Check your spam folder or <ResendLink>send a new code</ResendLink>."
          values={{
            // eslint-disable-next-line react/no-unstable-nested-components
            ResendLink: (chunks) => <Link data-testid="resend-otp" onClick={handleResend}>{chunks}</Link>
          }}
        />
      )}
      {!canResend && <FormattedMessage id="page.login.mfa.maxResendReached" defaultMessage="It's no longer possible to send a new verification code." /> }
    </div>
  );
};

export default ResendWrapper;
